<template>
  <b-modal
    ref="modal"
    size="xl"
    title="Create Online Category"
    title-class="font-18"
    :no-close-on-backdrop="true"
    hide-footer
    @hidden="$emit('hidden')"
    scrollable
    no-enforce-focus
  >
    <validationObserver ref="createView">
      <b-form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
        <b-form-group
          label="Root"
          label-for="input_root"
          label-cols-sm="3"
          v-if="level !== 1"
        >
          <label class="col-form-label col-sm-7">{{ root }}</label>
        </b-form-group>
        <!-- <validationProvider
          v-slot="{ errors }"
          name="MDC ID"
          :rules="{
            dynamicRequired: ['กรุณาระบุรหัสหมวดหมู่เป็นตัวเลข'],
            duplicateName: [
              isValidate.mdc_code,
              'รหัสซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
          }"
        > -->
        <validationProvider
          v-slot="{ errors }"
          name="MDC ID"
          :rules="{
            duplicateName: [
              isValidate.mdc_code,
              'รหัสซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
          }"
        >
          <b-form-group
            label="รหัส (Magento)"
            label-for="input_mdc_code"
            label-cols-sm="3"
          >
            <b-row class="m-0">
              <b-col cols="10" class="pl-0">
                <b-form-input
                  id="input_mdc_code"
                  type="number"
                  v-model="input.mdc_code"
                  :formatter="formatNumberMDCCode"
                  placeholder="ระบุรหัสหมวดหมู่"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid': !(errors && errors.length) && input.mdc_code,
                  }"
                  @keyup="onValidateMDCID($event)"
                >
                </b-form-input>
                <div v-if="errors && errors.length" class="validate-invalid">
                  <span>{{ errors[0] }}</span>
                </div>
              </b-col>
              <b-col>
                <i
                  class="ml-1 mt-2 bx bx-info-circle align-middle absolute text-grey f-18"
                  id="tooltip-filter"
                />
                <b-tooltip
                  target="tooltip-filter"
                  placement="right"
                  variant="info"
                >
                  รหัสหมวดหมู่ต้องตรงกับที่ระบุในระบบ MDC (Magento)
                  <br />หากไม่ต้องการ กรุณาระบุ 0
                </b-tooltip>
              </b-col>
            </b-row>
          </b-form-group>
        </validationProvider>
        <div class="form-group row mb-4">
          <label class="col-form-label col-sm-3">ชื่อหมวดหมู่</label>
          <div class="col-sm-9">
            <validationProvider
              v-slot="{ errors }"
              name="Thai Name"
              :rules="{
                dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาไทย'],
                duplicateName: [
                  isValidate.display_name_th,
                  'ชื่อหมวดหมู่ภาษาไทยซ้ำกับข้อมูลที่อยู่ในระบบ',
                ],
              }"
            >
              <div class="input-group check-length">
                <span class="input-group-append">
                  <span class="input-group-text">TH</span>
                </span>
                <input
                  id="input_displayname_th"
                  name="input_displayname_th"
                  type="text"
                  class="form-control"
                  maxlength="50"
                  v-model="input.display_name.th"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.th,
                  }"
                  v-on:keyup="onValidateDisplaynameTH($event)"
                />
                <span class="input-validate-length"
                  >{{ input.display_name.th.length }}/50
                </span>
              </div>
              <div
                v-if="errors && errors.length"
                class="validate-invalid invaild-left-bottom"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-form-label col-sm-3"></label>
          <div class="col-sm-9">
            <validationProvider
              v-slot="{ errors }"
              name="English Name"
              :rules="{
                dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาอังกฤษ'],
                duplicateName: [
                  isValidate.display_name_en,
                  'ชื่อหมวดหมู่ภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
                ],
                validateEngWithSpecialCharacters: true,
              }"
            >
              <div class="input-group check-length">
                <span class="input-group-append">
                  <span class="input-group-text">EN</span>
                </span>
                <input
                  id="input_displayname_en"
                  name="input_displayname_en"
                  type="text"
                  class="form-control"
                  maxlength="50"
                  v-model="input.display_name.en"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.en,
                  }"
                  v-on:keyup="onValidateDisplaynameEN($event)"
                />
                <span class="input-validate-length">
                  {{ input.display_name.en.length }}/50
                </span>
              </div>
              <div
                v-if="errors && errors.length"
                class="validate-invalid invaild-left-bottom"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </validationProvider>
          </div>
        </div>
        <!-- <validationProvider
          v-slot="{ errors }"
          name="Thai Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาไทย'],
            duplicateName: [
              isValidate.display_name_th,
              'ชื่อหมวดหมู่ภาษาไทยซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
            validateThaiWithSpecialCharactersWithoutNumber: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (ไทย)</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input
                  id="input_displayname_th"
                  name="input_displayname_th"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาไทย"
                  v-model="input.display_name.th"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.th,
                  }"
                  v-on:keyup="onValidateDisplaynameTH($event)"
                />
                <span class="input-group-append">
                  <span class="input-group-text"
                    >{{ input.display_name.th.length }}
                  </span>
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="English Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาอังกฤษ'],
            duplicateName: [
              isValidate.display_name_en,
              'ชื่อหมวดหมู่ภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
            validateEngWithSpecialCharactersWithoutNumber: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (อังกฤษ)</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input
                  id="input_displayname_en"
                  name="input_displayname_en"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาอังกฤษ"
                  v-model="input.display_name.en"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) && input.display_name.en,
                  }"
                  v-on:keyup="onValidateDisplaynameEN($event)"
                />
                <span class="input-group-append">
                  <span class="input-group-text"
                    >{{ input.display_name.en.length }}
                  </span>
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider> -->
        <validationProvider
          v-slot="{ errors }"
          name="Status"
          :rules="{ dynamicRequired: ['กรุณาเลือกสถานะ'] }"
        >
          <b-form-group
            label="สถานะ"
            label-for="input_status"
            label-cols-sm="3"
          >
            <div class="row col-sm-9 col-form-label">
              <b-form-radio
                v-model="input.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Active"
                style="margin-right:10px;"
                >Active</b-form-radio
              >
              <b-form-radio
                v-model="input.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Inactive"
                >Inactive</b-form-radio
              >
            </div>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <div class="form-group row mb-4">
          <label class="col-form-label col-sm-3">รูปประจำหมวดหมู่</label>
          <div class="col-form-label col-sm-5">
            <!-- <input
              class="form-control-file"
              type="file"
              ref="file"
              name="file"
              id="file"
              accept="image/*"
            /> -->
            <b-form-file
              placeholder="Choose file"
              accept="image/*"
              v-on:change="importImage($event)"
              v-model="input.file"
            ></b-form-file>
          </div>
          <div class="col-lg-4">
            <div class="card bg-dark-grey">
              <div class="card-body f-12">
                <div>รายละเอียดรูปภาพ</div>
                <ul class="mb-0">
                  <li>ใช้นามสกุล .jpg หรือ .png</li>
                  <li>ความสูงของรูปต้องอยู่ระหว่าง 40 ~ 400 px</li>
                  <li>ความกว้างของรูปต้องอยู่ระหว่าง 116 ~ 400 px</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row mb-4" v-if="isShowEditImage">
          <label class="col-form-label col-lg-3"></label>
          <div class="col-lg-2" v-if="isShowEditImage">
            <div style="position: relative; float: left">
              <!-- <img v-if="isShowEditImage" :src="urlImg" class="rounded" /> -->
              <img
                v-if="isShowEditImage && urlImg !== ''"
                :src="urlImg"
                class="rounded"
              />
              <div class="delete-img-block">
                <div class="remove-bt" @click="deleteUploadImage">
                  <label class="remove-txt">remove</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-form-group
          label="สำหรับจัดการสินค้า"
          label-for="input_is_control_product"
          label-cols-sm="3"
        >
          <div class="row col-sm-9 col-form-label">
            <b-form-radio-group
              :disabled="level !== lockLevel"
              v-model="input.is_control_product"
              name="input_is_control_product"
            >
              <b-form-radio
                class="custom-control custom-radio custom-radio-info mb-3"
                :value="true"
                style="margin-right:10px;"
                >Yes</b-form-radio
              >
              <b-form-radio
                class="custom-control custom-radio custom-radio-info mb-3"
                :value="false"
                >No</b-form-radio
              >
            </b-form-radio-group>
          </div>
        </b-form-group>
        <div
          class="form-group row mb-4"
          v-if="input.is_control_product === true"
        >
          <label class="col-form-label col-sm-3">Hybrid Category</label>
          <div class="col-sm-9">
            <div class="row">
              <div class="col-sm-10">
                <MappingHybridCategorySelector
                  :level="5"
                  :displayKey="`view_name`"
                  :idKey="`view_id`"
                  :childrenItemsKey="`items`"
                  :items="hybridCategoryItems"
                  :reload="isClearCategorySelector"
                  :isSelectLastChild="true"
                  @result="onHybridCategorySelector"
                ></MappingHybridCategorySelector>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="btn btn-success"
                  @click="onAddMappingHybridCategory"
                >
                  <i class="bx bx-save" />
                  Add
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="mappingHybridCategorytable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="mappingHybridCategoryItems.length == 0"
                    :bordered="true"
                    :items="mappingHybridCategoryItems"
                    align="center"
                    v-bind:fields="fields"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (firstRowOnPage + data.index) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-danger"
                          title="Delete"
                          @click="onDeleteMappingHybridCategory(data.item.id)"
                        >
                          <i class="bx bx-trash"></i>
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h4 class="card-title mb-4">Search Engine Optimization</h4>
        <div class="row">
          <div class="col-sm-3"></div>
          <div class="row col-sm-9 col-form-label">
            <div class="col-sm-6"><h6 style="text-align: center;">ไทย</h6></div>
            <div class="col-sm-6">
              <h6 style="text-align: center;">อังกฤษ</h6>
            </div>
          </div>
        </div>
        <!-- <b-form-group
          label="Content"
          label-for="input_content"
          label-cols-sm="3"
        >
          <div class="row">
            <div class="col-sm-6">
              <ckeditor v-model="input.content.th" :editor="editor"></ckeditor>
            </div>
            <div class="col-sm-6">
              <ckeditor v-model="input.content.en" :editor="editor"></ckeditor>
            </div>
          </div>
        </b-form-group> -->
        <ProductContentEditComponent
          v-model="input.content"
          :PathId="String(input.mdc_code)"
        ></ProductContentEditComponent>
        <!-- <div class="row">
          <div class="col-sm-3">
            <label for="input_content">
              Content
              <p class="mt-2">
                คำอธิบายแบบยาว <br/>
                <b-button size="sm" variant="warning" @click="isImageSingleUploadShow = !isImageSingleUploadShow"><i :class="`${'bx bx-image f-18'}`"></i>Upload Image</b-button>
                <ModalImageSingleUpload
                  v-model="isImageSingleUploadShow"
                  title="สร้าง URL จากรูปที่นำเข้า"
                   :path="'categories/contents'+(input.mdc_code?'/'+input.mdc_code:'')"
                   contentDescription="pim-product-content"
                ></ModalImageSingleUpload>
              </p>
            </label>
          </div>
          <div class="col-sm-9">
            <div class="row">
              <div class="col-sm-6">
                <tinymce
                  class="relative d-block form-group"
                  id="input_contentTH"
                  v-model="input.content.th"
                  :plugins="plugins"
                  :toolbar="toolbar"
                  :other_options="options"
                ></tinymce>
              </div>
              <div class="col-sm-6">
                <tinymce
                  class="relative d-block form-group"
                  id="input_contentEN"
                  v-model="input.content.en"
                  :plugins="plugins"
                  :toolbar="toolbar"
                  :other_options="options"
                ></tinymce>
              </div>
            </div>
          </div>
        </div> -->

        <b-form-group
          label="Title Tag"
          label-for="input_title_tag"
          label-cols-sm="3"
          class="mb-0"
        >
          <div class="row">
            <div class="col-sm-6">
              <textarea
                v-model="input.meta.title_tag.th"
                class="form-control"
                rows="3"
              ></textarea>
              <div>
                <b-form-checkbox
                  v-model="useDefaultValue"
                  value="1"
                  @change="onSelectDefaultTitleTagTH($event)"
                  class="custom-checkbox-info mb-3 mt-1"
                  >Use Default Value</b-form-checkbox
                >
              </div>
            </div>
            <div class="col-sm-6">
              <textarea
                v-model="input.meta.title_tag.en"
                class="form-control"
                rows="3"
              ></textarea>
              <div>
                <b-form-checkbox
                  v-model="useDefaultValue"
                  value="2"
                  @change="onSelectDefaultTitleTagEN($event)"
                  class="custom-checkbox-info mb-3 mt-1"
                  >Use Default Value</b-form-checkbox
                >
              </div>
            </div>
          </div>
        </b-form-group>

        <b-form-group
          label="Meta Description Tag"
          label-for="input_description_tag"
          label-cols-sm="3"
          class="mb-0"
        >
          <div class="row">
            <div class="col-sm-6">
              <textarea
                v-model="input.meta.description_tag.th"
                class="form-control"
                rows="3"
              ></textarea>
              <div>
                <b-form-checkbox
                  v-model="useDefaultValue"
                  value="3"
                  @change="onSelectDefaultDescriptionTagTH($event)"
                  class="custom-checkbox-info mb-3 mt-1"
                  >Use Default Value</b-form-checkbox
                >
              </div>
            </div>
            <div class="col-sm-6">
              <textarea
                v-model="input.meta.description_tag.en"
                class="form-control"
                rows="3"
              ></textarea>
              <div class="col-form-label">
                <b-form-checkbox
                  v-model="useDefaultValue"
                  value="4"
                  @change="onSelectDefaultDescriptionTagEN($event)"
                  class="custom-checkbox-info mb-3"
                  >Use Default Value</b-form-checkbox
                >
              </div>
            </div>
          </div>
        </b-form-group>
        <b-form-group
          label="Meta Keyword"
          label-for="input_keyword"
          label-cols-sm="3"
        >
          <div class="row col-form-label">
            <div class="col-sm-6">
              <b-form-input
                type="text"
                v-model="input.meta.keyword.th"
              ></b-form-input>
            </div>
            <div class="col-sm-6">
              <b-form-input
                type="text"
                v-model="input.meta.keyword.en"
              ></b-form-input>
            </div>
          </div>
        </b-form-group>
        <b-form-group
          label="Cononical Tag"
          label-for="input_cononical_tag"
          label-cols-sm="3"
        >
          <div class="row col-form-label">
            <div class="col-sm-6">
              <b-form-input
                type="text"
                v-model="input.meta.cononical_tag.th"
              ></b-form-input>
            </div>
            <div class="col-sm-6">
              <b-form-input
                type="text"
                v-model="input.meta.cononical_tag.en"
              ></b-form-input>
            </div>
          </div>
        </b-form-group>
        <b-form-group
          label="Meta Robot"
          label-for="input_robot"
          label-cols-sm="3"
        >
          <div class="row col-form-label">
            <div class="col-sm-6">
              <b-form-input
                type="text"
                v-model="input.meta.robot.th"
              ></b-form-input>
            </div>
            <div class="col-sm-6">
              <b-form-input
                type="text"
                v-model="input.meta.robot.en"
              ></b-form-input>
            </div>
          </div>
        </b-form-group>
        <b-form-group
          label="Sitemap Priority"
          label-for="input_sitemap_priority"
          label-cols-sm="3"
        >
          <div class="row col-form-label">
            <div class="col-sm-6">
              <validationProvider
                v-slot="{ errors }"
                name="Sitemap Priority Thai"
                :rules="{
                  duplicateName: [
                    isValidate.sitemap_priority_th,
                    'กรุณาระบุ Sitemap Priority (ภาษาไทย) ไม่เกิน 100',
                  ],
                }"
              >
                <b-form-input
                  type="number"
                  step=".01"
                  v-model="input.meta.sitemap_priority.th"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      input.meta.sitemap_priority.th,
                  }"
                  @keyup="onValidateSitemapPriorityTH($event)"
                ></b-form-input>
                <div v-if="errors && errors.length" class="validate-invalid">
                  <span>{{ errors[0] }}</span>
                </div>
              </validationProvider>
            </div>
            <div class="col-sm-6">
              <validationProvider
                v-slot="{ errors }"
                name="Sitemap Priority Eng"
                :rules="{
                  duplicateName: [
                    isValidate.sitemap_priority_en,
                    'กรุณาระบุ Sitemap Priority (ภาษาอังกฤษ) ไม่เกิน 100',
                  ],
                }"
              >
                <b-form-input
                  type="number"
                  step=".01"
                  v-model="input.meta.sitemap_priority.en"
                  value="0"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      input.meta.sitemap_priority.en,
                  }"
                  @keyup="onValidateSitemapPriorityEN($event)"
                ></b-form-input>
                <div v-if="errors && errors.length" class="validate-invalid">
                  <span>{{ errors[0] }}</span>
                </div>
              </validationProvider>
            </div>
          </div>
        </b-form-group>
        <div slot="modal-footer">
          <div class="button-items" style="float: right;">
            <button type="submit" class="btn btn-primary">
              <i class="bx bx-save" />Save
            </button>
            <button type="reset" class="btn btn-light">
              <i class="bx bx-reset" />Reset
            </button>
          </div>
          <!-- <button
            type="submit"
            class="btn btn-primary"
            style="float: right;"
          >
            Save
          </button>
          <button type="reset" class="btn btn-secondary"  style="float: right;">
            Reset
          </button> -->
        </div>
      </b-form>
    </validationObserver>
  </b-modal>
</template>
<script>
import ProductContentEditComponent from '../../share/product-content-edit-component.vue'
import { FormatQty } from '@/helpers/utils/format-qty.js'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import onlineCategoryService from '@/helpers/service/online-category-service'
import filecloudService from '@/helpers/service/filecloud-service'
import { StatusEnum } from '@/enum/status.enum.js'
import { OnlineLockLevel } from '@/enum/online-category.enum.js'
import { eventBus } from '@/main.js'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import MappingHybridCategorySelector from '@/components/mappinghybridcategory/mapping-hybrid-category-selector'
import tinymce from 'vue-tinymce-editor'
import ModalImageSingleUpload from '../../share/modal-image-single-upload.vue'
export default {
  components: {
    // ckeditor: CKEditor.component,
    MappingHybridCategorySelector,
    //  tinymce,
    // ModalImageSingleUpload,
    ProductContentEditComponent,
  },
  props: {
    activeModal: {
      type: Boolean,
      default: false,
    },
    parent_id: {
      type: String,
      default: null,
    },
    level: {
      type: Number,
      default: 0,
    },
    root: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      urlImg: '',
      mappingHybridCategoryValue: null,
      mappingHybridCategoryItems: [],
      hybridCategoryItems: [],
      useDefaultValue: [],
      editor: ClassicEditor,
      openModal: false,
      input: {
        id: null,
        mdc_code: null,
        parent_id: null,
        level: 0,
        display_name: {
          th: '',
          en: '',
        },
        content: {
          th: '',
          en: '',
        },
        meta: {
          title_tag: {
            th: '',
            en: '',
          },
          description_tag: {
            th: '',
            en: '',
          },
          keyword: {
            th: '',
            en: '',
          },
          cononical_tag: {
            th: '',
            en: '',
          },
          robot: {
            th: '',
            en: '',
          },
          sitemap_priority: {
            th: null,
            en: null,
          },
        },
        // images: [
        //   {
        //     url: '',
        //     size: '',
        //   },
        // ],
        status: StatusEnum.ACTIVE,
        is_control_product: false,
        mapping_hybrid_categories: [],
        isSelectHybridCategory: false,
        image: [],
        file: null,
        originalImg: null,
        thumpImg: null,
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      isValidate: {
        mdc_code: false,
        display_name_th: false,
        display_name_en: false,
        sitemap_priority_th: false,
        sitemap_priority_en: false,
      },
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'code_level_1',
          label: 'รหัส Level 1',
          sortable: true,
        },
        {
          key: 'display_name_level_1.th',
          label: 'ชื่อ Level 1 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_1.en',
          label: 'ชื่อ Level 1 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_2',
          label: 'รหัส Level 2',
          sortable: true,
        },
        {
          key: 'display_name_level_2.th',
          label: 'ชื่อ Level 2 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_2.en',
          label: 'ชื่อ Level 2 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_3',
          label: 'รหัส Level 3',
          sortable: true,
        },
        {
          key: 'display_name_level_3.th',
          label: 'ชื่อ Level 3 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_3.en',
          label: 'ชื่อ Level 3 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_4',
          label: 'รหัส Level 4',
          sortable: true,
        },
        {
          key: 'display_name_level_4.th',
          label: 'ชื่อ Level 4 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_4.en',
          label: 'ชื่อ Level 4 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'code_level_5',
          label: 'รหัส Level 5',
          sortable: true,
        },
        {
          key: 'display_name_level_5.th',
          label: 'ชื่อ Level 5 (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_level_5.en',
          label: 'ชื่อ Level 5 (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      perPage: 100,
      firstRowOnPage: 1,
      isClearCategorySelector: false,
      lockLevel: OnlineLockLevel,
      isShowEditImage: false,
      // Tinymce Editor
      plugins: [
        'advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker',
        'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
        'save table contextmenu directionality emoticons template paste textcolor',
      ],
      toolbar:
        'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons',
      options: {
        height: 200,
        style_formats: [
          { title: 'Bold text', inline: 'b' },
          { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } },
          { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } },
          { title: 'Example 1', inline: 'span', classes: 'example1' },
          { title: 'Example 2', inline: 'span', classes: 'example2' },
          { title: 'Table styles' },
          { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' },
        ],
      },
      isImageSingleUploadShow: false,
    }
  },
  watch: {
    activeModal: function(value) {
      if (value) {
        this.$refs.modal.show()
        this.mappingHybridCategoryValue = null
        this.mappingHybridCategoryItems = []
        this.input = {
          id: null,
          mdc_code: null,
          parent_id: null,
          level: 0,
          display_name: {
            th: '',
            en: '',
          },
          content: {
            th: '',
            en: '',
          },
          meta: {
            title_tag: {
              th: '',
              en: '',
            },
            description_tag: {
              th: '',
              en: '',
            },
            keyword: {
              th: '',
              en: '',
            },
            cononical_tag: {
              th: '',
              en: '',
            },
            robot: {
              th: '',
              en: '',
            },
            sitemap_priority: {
              th: null,
              en: null,
            },
          },
          image: [
            {
              url: '',
              size: '',
            },
          ],
          status: StatusEnum.ACTIVE,
          is_control_product: false,
          mapping_hybrid_categories: [],
          isSelectHybridCategory: false,
          create_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
          update_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
        }
        this.isValidate = {
          mdc_code: false,
          display_name_th: false,
          display_name_en: false,
          sitemap_priority_th: false,
          sitemap_priority_en: false,
        }
        this.useDefaultValue = []
        this.deleteUploadImage()
      } else {
        this.$refs.modal.hide()
      }
    },
  },
  async mounted() {
    await this.getHybridCategory()
  },
  methods: {
    async onSubmit() {
      this.$refs.createView.validate().then(async result => {
        if (this.input.isSelectHybridCategory) {
          this.$utils.notificationAck(
            'warning',
            'กรุณาเพิ่มหรือลบ Hybrid Category ก่อน'
          )
          return
        }
        if (result) {
          // if (
          //   this.input.is_control_product === true &&
          //   this.mappingHybridCategoryItems.length === 0
          // ) {
          //   this.$utils.notification(
          //     'error',
          //     'กรุณาเพิ่ม Hybrid Category',
          //     2000
          //   )
          // } else {

          if (await this.checkUploadImage()) {
            this.input.display_name.th = this.input.display_name.th.trim()
            this.input.display_name.en = this.input.display_name.en.trim()
            this.mappingHybridCategoryItems.forEach(element => {
              let tempParentItems = []
              if (element.level === 1) {
                let mapping_hybrid_categories = {
                  hybrid_category_id: element.id,
                  hybrid_parent_id: null,
                  hybrid_code: element.code_level_1,
                  hybrid_level: 1,
                  hybrid_category_display_name: {
                    th: element.display_name.th,
                    en: element.display_name.en,
                  },
                  hybrid_parent_categories: tempParentItems,
                }
                this.input.mapping_hybrid_categories.push(
                  mapping_hybrid_categories
                )
              } else if (element.level === 2) {
                let tempParentLevel1 = {
                  pim_id: element.id_level_1,
                  parent_id: null,
                  code: element.code_level_1,
                  level: 1,
                  display_name: {
                    th: element.display_name_level_1.th,
                    en: element.display_name_level_1.en,
                  },
                }
                tempParentItems.push(tempParentLevel1)
                let mapping_hybrid_categories = {
                  hybrid_category_id: element.id,
                  hybrid_parent_id: element.id_level_1,
                  hybrid_code: element.code_level_2,
                  hybrid_level: 2,
                  hybrid_category_display_name: {
                    th: element.display_name.th,
                    en: element.display_name.en,
                  },
                  hybrid_parent_categories: tempParentItems,
                }
                this.input.mapping_hybrid_categories.push(
                  mapping_hybrid_categories
                )
              } else if (element.level === 3) {
                let tempParentLevel1 = {
                  pim_id: element.id_level_1,
                  parent_id: null,
                  code: element.code_level_1,
                  level: 1,
                  display_name: {
                    th: element.display_name_level_1.th,
                    en: element.display_name_level_1.en,
                  },
                }
                tempParentItems.push(tempParentLevel1)
                let tempParentLevel2 = {
                  pim_id: element.id_level_2,
                  parent_id: element.id_level_1,
                  code: element.code_level_2,
                  level: 2,
                  display_name: {
                    th: element.display_name_level_2.th,
                    en: element.display_name_level_2.en,
                  },
                }
                tempParentItems.push(tempParentLevel2)
                let mapping_hybrid_categories = {
                  hybrid_category_id: element.id,
                  hybrid_parent_id: element.id_level_2,
                  hybrid_code: element.code_level_3,
                  hybrid_level: 3,
                  hybrid_category_display_name: {
                    th: element.display_name.th,
                    en: element.display_name.en,
                  },
                  hybrid_parent_categories: tempParentItems,
                }
                this.input.mapping_hybrid_categories.push(
                  mapping_hybrid_categories
                )
              } else if (element.level === 4) {
                let tempParentLevel1 = {
                  pim_id: element.id_level_1,
                  parent_id: null,
                  code: element.code_level_1,
                  level: 1,
                  display_name: {
                    th: element.display_name_level_1.th,
                    en: element.display_name_level_1.en,
                  },
                }
                tempParentItems.push(tempParentLevel1)
                let tempParentLevel2 = {
                  pim_id: element.id_level_2,
                  parent_id: element.id_level_1,
                  code: element.code_level_2,
                  level: 2,
                  display_name: {
                    th: element.display_name_level_2.th,
                    en: element.display_name_level_2.en,
                  },
                }
                tempParentItems.push(tempParentLevel2)
                let tempParentLevel3 = {
                  pim_id: element.id_level_3,
                  parent_id: element.id_level_2,
                  code: element.code_level_3,
                  level: 3,
                  display_name: {
                    th: element.display_name_level_3.th,
                    en: element.display_name_level_3.en,
                  },
                }
                tempParentItems.push(tempParentLevel3)
                let mapping_hybrid_categories = {
                  hybrid_category_id: element.id,
                  hybrid_parent_id: element.id_level_3,
                  hybrid_code: element.code_level_4,
                  hybrid_level: 4,
                  hybrid_category_display_name: {
                    th: element.display_name.th,
                    en: element.display_name.en,
                  },
                  hybrid_parent_categories: tempParentItems,
                }
                this.input.mapping_hybrid_categories.push(
                  mapping_hybrid_categories
                )
              } else if (element.level === 5) {
                let tempParentLevel1 = {
                  pim_id: element.id_level_1,
                  parent_id: null,
                  code: element.code_level_1,
                  level: 1,
                  display_name: {
                    th: element.display_name_level_1.th,
                    en: element.display_name_level_1.en,
                  },
                }
                tempParentItems.push(tempParentLevel1)
                let tempParentLevel2 = {
                  pim_id: element.id_level_2,
                  parent_id: element.id_level_1,
                  code: element.code_level_2,
                  level: 2,
                  display_name: {
                    th: element.display_name_level_2.th,
                    en: element.display_name_level_2.en,
                  },
                }
                tempParentItems.push(tempParentLevel2)
                let tempParentLevel3 = {
                  pim_id: element.id_level_3,
                  parent_id: element.id_level_2,
                  code: element.code_level_3,
                  level: 3,
                  display_name: {
                    th: element.display_name_level_3.th,
                    en: element.display_name_level_3.en,
                  },
                }
                tempParentItems.push(tempParentLevel3)
                let tempParentLevel4 = {
                  pim_id: element.id_level_4,
                  parent_id: element.id_level_3,
                  code: element.code_level_4,
                  level: 4,
                  display_name: {
                    th: element.display_name_level_4.th,
                    en: element.display_name_level_4.en,
                  },
                }
                tempParentItems.push(tempParentLevel4)
                let mapping_hybrid_categories = {
                  hybrid_category_id: element.id,
                  hybrid_parent_id: element.id_level_4,
                  hybrid_code: element.code_level_5,
                  hybrid_level: 5,
                  hybrid_category_display_name: {
                    th: element.display_name.th,
                    en: element.display_name.en,
                  },
                  hybrid_parent_categories: tempParentItems,
                }
                this.input.mapping_hybrid_categories.push(
                  mapping_hybrid_categories
                )
              }
            })
            // fix mdc_code = 0
            if (String(this.input.mdc_code === '0' || !this.input.mdc_code)) {
              this.input.mdc_code = 0
            }
            if (!this.input.meta.sitemap_priority.en)
              this.input.meta.sitemap_priority.en = 0
            if (!this.input.meta.sitemap_priority.th)
              this.input.meta.sitemap_priority.th = 0
            this.$emit('createView', this.input)
          }
        } else {
          this.$utils.notificationAck('warning', 'กรุณากรอกข้อมูลให้ครบถ้วน')
          return
        }
      })
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.mappingHybridCategoryValue = null
            this.mappingHybridCategoryItems = []
            this.input = {
              id: null,
              mdc_code: null,
              parent_id: null,
              level: 0,
              display_name: {
                th: '',
                en: '',
              },
              content: {
                th: '',
                en: '',
              },
              meta: {
                title_tag: {
                  th: '',
                  en: '',
                },
                description_tag: {
                  th: '',
                  en: '',
                },
                keyword: {
                  th: '',
                  en: '',
                },
                cononical_tag: {
                  th: '',
                  en: '',
                },
                robot: {
                  th: '',
                  en: '',
                },
                sitemap_priority: {
                  th: null,
                  en: null,
                },
              },
              image: [
                {
                  url: '',
                  size: '',
                },
              ],
              status: StatusEnum.ACTIVE,
              is_control_product: false,
              mapping_hybrid_categories: [],
              create_info: {
                timestamp: '',
                user_id: '',
                user_name: '',
              },
              update_info: {
                timestamp: '',
                user_id: '',
                user_name: '',
              },
            }
            this.isClearCategorySelector = !this.isClearCategorySelector
            this.isValidate = {
              mdc_code: false,
              display_name_th: false,
              display_name_en: false,
              sitemap_priority_th: false,
              sitemap_priority_en: false,
            }
            this.useDefaultValue = []
            this.deleteUploadImage()
          }
        })
    },
    async onValidateDisplaynameTH() {
      if (
        !(
          this.input.display_name.th.trim() === '' ||
          this.input.display_name.th.trim() === null ||
          this.input.display_name.th.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameTH', this.input.display_name.th.trim())
        if (this.parent_id !== null) {
          params.append('parent_id', this.parent_id)
        }
        let result = await onlineCategoryService.headOnlineCategoryAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.input.display_name.en.trim() === '' ||
          this.input.display_name.en.trim() === null ||
          this.input.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameEN', this.input.display_name.en.trim())
        if (this.parent_id !== null) {
          params.append('parent_id', this.parent_id)
        }
        let result = await onlineCategoryService.headOnlineCategoryAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateMDCID() {
      if (!this.componentModel.mdc_code) return
      if (
        !(
          this.input.mdc_code.trim() === '' ||
          this.input.mdc_code.trim() === null ||
          this.input.mdc_code.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('mdc_code', this.input.mdc_code.trim())
        if (this.parent_id !== null) {
          params.append('parent_id', this.parent_id)
        }
        let result = await onlineCategoryService.headOnlineCategoryAsync(params)
        if (result.status === 200) {
          // if === 0 then false
          //console.log(this.input.mdc_code)
          if (String(this.input.mdc_code) === '0') {
            this.isValidate.mdc_code = false
          } else {
            this.isValidate.mdc_code = true
          }
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.mdc_code = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    onValidateSitemapPriorityTH() {
      if (
        !(
          this.input.meta.sitemap_priority.th.trim() === '' ||
          this.input.meta.sitemap_priority.th.trim() === null ||
          this.input.meta.sitemap_priority.th.trim() === undefined
        )
      ) {
        if (Number(this.input.meta.sitemap_priority.th.trim()) >= 100) {
          this.isValidate.sitemap_priority_th = true
        } else {
          this.isValidate.sitemap_priority_th = false
        }
      }
    },
    onValidateSitemapPriorityEN() {
      if (
        !(
          this.input.meta.sitemap_priority.en.trim() === '' ||
          this.input.meta.sitemap_priority.en.trim() === null ||
          this.input.meta.sitemap_priority.en.trim() === undefined
        )
      ) {
        if (Number(this.input.meta.sitemap_priority.en.trim()) >= 100) {
          this.isValidate.sitemap_priority_en = true
        } else {
          this.isValidate.sitemap_priority_en = false
        }
      }
    },
    onSelectDefaultTitleTagTH(value) {
      const index = value.findIndex(element => element === '1')
      if (index !== -1) {
        this.input.meta.title_tag.th =
          this.input.display_name.th 
      } else {
        this.input.meta.title_tag.th = ''
      }
    },
    onSelectDefaultTitleTagEN(value) {
      const index = value.findIndex(element => element === '2')
      if (index !== -1) {
        this.input.meta.title_tag.en =
          this.input.display_name.en 
      } else {
        this.input.meta.title_tag.en = ''
      }
    },
    onSelectDefaultDescriptionTagTH(value) {
      const index = value.findIndex(element => element === '3')
      if (index !== -1) {
        this.input.meta.description_tag.th =
          this.input.display_name.th
      } else {
        this.input.meta.description_tag.th = ''
      }
    },
    onSelectDefaultDescriptionTagEN(value) {
      const index = value.findIndex(element => element === '4')
      if (index !== -1) {
        this.input.meta.description_tag.en =
          this.input.display_name.en
      } else {
        this.input.meta.description_tag.en = ''
      }
    },
    onValidate1Decimal() {},
    async getHybridCategory() {
      let params = new URLSearchParams()
      params.append('status', StatusEnum.ACTIVE)
      params.append('isControlProduct', true)
      let result = await hybridCategoryService.getMappingHybridCategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data.length) {
          this.hybridCategoryItems = result.data
        }
      }
    },
    onHybridCategorySelector(obj) {
      this.mappingHybridCategoryValue = obj.id
      this.input.isSelectHybridCategory = obj.isSuccess

      // this.categorySelector.isSuccess = obj.isSuccess
      // this.categorySelector.valueSelected = obj.value
    },
    async onAddMappingHybridCategory() {
      if (
        this.mappingHybridCategoryValue !== null &&
        this.mappingHybridCategoryItems.findIndex(
          element => element.id === this.mappingHybridCategoryValue
        ) === -1
      ) {
        let params = new URLSearchParams()
        params.append('pageSize', this.perPage)
        params.append('id', this.mappingHybridCategoryValue)
        let result = await hybridCategoryService.getHybridCategoryListAsync(
          params
        )
        if (result.status === 200) {
          this.mappingHybridCategoryItems.push(result.data.items[0])
          this.isClearCategorySelector = !this.isClearCategorySelector
          console.log(this.mappingHybridCategoryItems)
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          console.log('error', result.response.data.message)
        } else {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      } else {
        this.$utils.notification('error', 'มีการ Add ข้อมูลนี้ไปแล้ว', 2000)
      }
    },
    onDeleteMappingHybridCategory(id) {
      this.mappingHybridCategoryItems.splice(
        this.mappingHybridCategoryItems.findIndex(element => element.id === id),
        1
      )
    },
    formatNumberMDCCode(e) {
      return String(e).substring(0, 9)
    },
    async checkUploadImage() {
      var checkUpload = true
      var isUploadError = false
      if (
        this.input.originalImg !== null &&
        this.input.originalImg !== undefined
      ) {
        let dataOriginal = new FormData()
        dataOriginal.append(
          'file',
          this.input.originalImg,
          `${this.input.id}.jpg`
        )
        var uniq = '' + new Date().getTime()
        dataOriginal.append('bucket', `${process.env.VUE_APP_BUCKET_PIM}`)
        dataOriginal.append('path', `tmp/categories/original`)
        dataOriginal.append('key', `${uniq}.jpg`)
        dataOriginal.append('content_description', `pim-categories`)
        dataOriginal.append('is_upsert', true)
        let resultUploadOriginal = await filecloudService.uploadImageAsync(
          dataOriginal
        )
        if (resultUploadOriginal.status === 201) {
          var imgList = [
            {
              size: 'original',
              url: resultUploadOriginal.data.content_url,
            },
          ]
          this.input.image = imgList
          checkUpload = true
        } else {
          checkUpload = false
          isUploadError = true
          this.$utils.notificationConfirm('error', 'ไม่สามารถ Upload รูปภาพ')
        }
      }
      return checkUpload && isUploadError === false
    },
    importImage(e) {
      var vm = this
      const file = e.target.files[0]
      if (file.type.match(/image.*/)) {
        var reader = new FileReader()
        reader.onload = function(readerEvent) {
          var image = new Image()
          image.onload = function(imageEvent) {
            if (
              40 <= Number(image.height) &&
              Number(image.height) <= 400 &&
              116 <= Number(image.width) &&
              Number(image.width) <= 400
            ) {
              var canvas = document.createElement('canvas')
              canvas.width = image.width
              canvas.height = image.height
              canvas
                .getContext('2d')
                .drawImage(image, 0, 0, image.width, image.height)
              var dataUrl = canvas.toDataURL('image/jpeg')
              var resizedImage = vm.dataURLToBlob(dataUrl)

              vm.urlImg = dataUrl

              // vm.$set(vm.input, 'urlImg', dataUrl)
              vm.input.originalImg = resizedImage
              console.log('input', vm.urlImg, vm.input.originalImg)
              vm.isShowEditImage = true
            } else {
              vm.input.file = null
              vm.input.originalImg = null
              vm.urlImg = ''
              vm.$utils.notification('error', 'ขนาดรูปไม่เหมาะสม', 2000)
            }
          }
          image.src = readerEvent.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    dataURLToBlob(dataURL) {
      let BASE64_MARKER = ';base64,'
      if (dataURL.indexOf(BASE64_MARKER) == -1) {
        let parts = dataURL.split(',')
        let contentType = parts[0].split(':')[1]
        let raw = parts[1]

        return new Blob([raw], { type: contentType })
      }

      let parts = dataURL.split(BASE64_MARKER)
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length

      let uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }

      return new Blob([uInt8Array], { type: contentType })
    },
    async deleteUploadImage() {
      this.input.file = []
      this.input.originalImg = null
      this.input.image = []
      this.urlImg = ''
      this.isShowEditImage = false
    },
  },
}
</script>
<style scoped>
.ml-100 {
  margin-top: -100px;
}
.image-preview-brand {
  width: 100px;
  height: 100px;
}
.delete-img-block {
  position: absolute;
  bottom: 2px;
  right: 2px;
}
.remove-bt {
  width: 51px;
  height: 17px;
  background-color: #f46a6a;
  border-radius: 8px;
  padding-left: 2px;
}
.remove-txt {
  font-size: 10px;
  color: white;
  margin-left: 3px;
  cursor: pointer;
}
</style>
